import React from "react";
import { Box, Typography, Avatar, Stack } from "@mui/material";
import eventImg from "../../assets/img/event.png";
import { Link, useNavigate } from "react-router-dom";

/**
 * EventCard
 *
 * A compact, modern event card inspired by the provided design.
 * Content is driven by props so it can be reused.
 */
const EventCard = ({
  day = "24",
  month = "Sept",
  city,
  venue,
  organizer,
  titleLine1 = "Summer Music",
  ticket,
  bg,
  id,
}) => {
  const route = useNavigate();

  
  // `https://ticket.reisty.com/event/${name
  //   ?.split(' ')
  //   .join('-')}/${selectedRestaurant}`
  const handleClick = () => {
    route(`/event/${titleLine1?.split(" ").join("-")}/${id}`);
  };
  return (
    <Box
      onClick={handleClick}
      sx={{
        borderRadius: 4,
        p: 3,
        backgroundImage: `linear-gradient(
  rgba(0, 0, 0, 0.65),
  rgba(0, 0, 0, 0.85)
), url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#ffffff",
        width: "70%",
        gap: 3,
        flexShrink: 0,
        height: 150,
        cursor: "pointer",
      }}
    >
      {/* Left section: date + venue + title */}

      {/* Date badge */}
      <Box sx={{ display: "flex", columnGap: 3, alignItems: "center", mb: 2 }}>
        <Box
          sx={{
            width: 54,
            height: 54,
            borderRadius: "999px",
            bgcolor: "#020617",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "#ffffff",
            flexShrink: 0,
          }}
        >
          <Typography sx={{ fontWeight: 700, fontSize: 15, lineHeight: 1.2 }}>
            {day}
          </Typography>
          <Typography sx={{ fontSize: 10, opacity: 0.8 }}>{month}</Typography>
        </Box>
        <Box sx={{}}>
          {/* <Typography
            sx={{
              fontSize: 14,
              fontWeight: 500,
              lineHeight: 1.3,
            }}
          >
            {city}
          </Typography> */}
          <Typography
            className="two-line-ellipsis"
            sx={{
              fontSize: 12,
              fontWeight: 400,
              lineHeight: 1.3,
            }}
          >
            {venue}
          </Typography>
        </Box>
      </Box>

      {/* Text content */}

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "end",
        }}
      >
        <Box>
          <Typography
            sx={{ fontSize: 12, fontWeight: 400, opacity: 0.8, mb: 1.5 }}
          >
            {organizer}
          </Typography>

          <Typography
            className="two-line-ellipsis"
            sx={{
              fontSize: 24,
              fontWeight: 600,
              lineHeight: 1.1,
              fontFamily: "optima",
            }}
          >
            {titleLine1}
          </Typography>
        </Box>

        {/* Right section: avatars + guest count */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          {ticket > 0 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                pr: 1,
                pl: 0.5,
                py: 0.5,
                borderRadius: 999,
                backgroundColor: "#1E293B",
                gap: 0.5,
              }}
            >
              <Stack direction="row" spacing={-1} sx={{ mr: 1 }}>
                <Avatar
                  src={bg}
                  sx={{ width: 28, height: 28, border: "2px solid #1E293B" }}
                />
                <Avatar
                  src={bg}
                  sx={{ width: 28, height: 28, border: "2px solid #1E293B" }}
                />
              </Stack>
              <Avatar
                sx={{
                  width: 32,
                  height: 32,
                  bgcolor: "#F9FAFB",
                  color: "#111827",
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                {ticket}
              </Avatar>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default EventCard;
